<!-- ****************************** -->
<!-- *************** Admin *************** -->
<!-- ****************************** -->
<div class="nav_container">
  <ul>
    <div>
      <div class="mb-4">
        <!-- ***************** FORMATION ***************** -->
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Formation
        </li>
        <!-- <li>
          <a [routerLink]="['appels/certificats']" class="nav_item" style="padding-top: 3px; padding-bottom: 3px"
            routerLinkActive="active-link">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" enable-background="new 0 0 32 32"
              xml:space="preserve" style="width: 29px; height: 30px; margin-left: -4px">
              <polyline fill="none" stroke="#E5E8EC" stroke-width="1.3" stroke-miterlimit="10"
                points="17.4,21 21.3,26.9 22.7,23.6 26.3,23.6 22.6,18 " />
              <polyline fill="none" stroke="#E5E8EC" stroke-width="1.3" stroke-miterlimit="10"
                points="14.6,21 10.7,26.9 9.3,23.6 5.7,23.6 9.4,18 " />
              <path fill="none" stroke="#E5E8EC" stroke-width="1.3" stroke-miterlimit="10"
                d="M17.2,4.4L19,5.7L21.2,6c0.9,0.1,1.6,0.8,1.7,1.7 l0.4,2.2l1.3,1.8c0.5,0.7,0.5,1.7,0,2.5L23.3,16L23,18.2c-0.1,0.9-0.8,1.6-1.7,1.7L19,20.3l-1.8,1.3c-0.7,0.5-1.7,0.5-2.5,0L13,20.3 L10.8,20c-0.9-0.1-1.6-0.8-1.7-1.7L8.7,16l-1.3-1.8c-0.5-0.7-0.5-1.7,0-2.5L8.7,10L9,7.8C9.2,6.9,9.9,6.2,10.8,6L13,5.7l1.8-1.3 C15.5,3.9,16.5,3.9,17.2,4.4z" />
            </svg>
            <span class="ml-2">Certificats</span>
          </a>
        </li> -->
        <li>
          <a [routerLink]="['users/apprenants']" class="nav_item" style="padding-top: 3px; padding-bottom: 3px"
            routerLinkActive="active-link">
            <svg style="
                margin-left: -5px;
                enable-background: new 0 0 512 512;
                width: 28px;
                height: 28px;
              " version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <path
                d="M465.4,247c-2.2-22-12.4-43-28.9-58.4c-17.1-15.9-39.3-24.7-62.7-24.7c-41.5,0-77.3,27.4-88.5,67c-7-7-18.5-11.7-29.3-11.7  c-10.8,0-22.3,4.7-29.3,11.7c-11.2-39.6-47-67-88.5-67c-23.3,0-45.6,8.7-62.7,24.6C59,204,48.8,225,46.6,247H32v18h14.6  c2.2,22,12.4,43,28.9,58.4c17.1,15.9,39.3,24.7,62.7,24.7c50.8,0,92.1-41.2,92.1-92c0-0.1,0-0.1,0-0.1h0c0-9.9,11.5-21.6,25.7-21.6  s25.7,11.7,25.7,21.6h0c0,0,0,0,0,0.1c0,50.8,41.3,92,92.1,92c23.3,0,45.6-8.7,62.7-24.7c16.5-15.4,26.7-36.5,28.9-58.5H480v-18  H465.4z M373.8,333c-42.5,0-77-34.6-77-77c0-42.5,34.6-77,77-77c42.5,0,77,34.6,77,77C450.8,298.5,416.3,333,373.8,333z M138.2,333  c-42.5,0-77-34.6-77-77c0-42.5,34.6-77,77-77c42.5,0,77,34.6,77,77C215.2,298.5,180.7,333,138.2,333z"
                fill="#F3F4F6" />
            </svg>
            <span style="margin-left: 10px">Apprenants</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['application-simplify/listwebinaire']" class="nav_item"
            style="padding-top: 3px; padding-bottom: 3px" routerLinkActive="active-link">
            <svg style="margin-left: -5px; width: 28px; height: 28px" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15 10L19 7V17L15 14V17C15 18.1046 14.1046 19 13 19H5C3.89543 19 3 18.1046 3 17V7C3 5.89543 3.89543 5 5 5H13C14.1046 5 15 5.89543 15 7V10Z"
                stroke="#E5E8EC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <circle cx="9" cy="11" r="2" stroke="#E5E8EC" stroke-width="1.5" />
            </svg>
            <span style="margin-left: 10px">Participants webinaire</span>
          </a>
        </li>
      </div>
      <!-- ************** MENTORS ************** -->
      <div class="mb-4">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Mentorat
        </li>
        <ng-container *ngIf="isAdminFcc">
          <li class="mb-2">
            <a [routerLink]="['users/list-mentors']" class="nav_item" style="padding-top: 3px; padding-bottom: 3px"
              routerLinkActive="active-link">
              <svg style="margin-left: -5px; width: 22px; height: 22px" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <!-- Icône de documents/candidatures (contour) -->
                <path stroke="#F3F4F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                  d="M14 2H6C4.9 2 4 2.9 4 4v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6z" />
                <path stroke="#F3F4F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                  d="M14 2v6h6M8 15h8M8 11h8M8 7h5" />
              </svg>
              <span style="margin-left: 10px">Gestion Candidatures</span>
            </a>
          </li>
          <li>
            <a [routerLink]="['mentorat/groupe']" class="nav_item" routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }">
              <svg style="margin-left: -5px; width: 24px; height: 24px" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <!-- Icône de groupe de personnes -->
                <path fill="currentColor"
                  d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
              </svg>
              <span class="ml-3">Gestion Groupes</span>
            </a>
          </li>
          <li>
            <a [routerLink]="['mentorat/gestionmentor']" class="nav_item" routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }">
              <svg style="margin-left: -5px; width: 24px; height: 24px" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <!-- Icône de groupe de personnes -->
                <path fill="currentColor"
                  d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
              </svg>
              <span class="ml-3">Gestion Mentors</span>
            </a>
          </li>
        </ng-container>
        <li *ngIf="!isAdminFcc">
          <a [routerLink]="['users/list-mentors']" class="nav_item" style="padding-top: 3px; padding-bottom: 3px"
            routerLinkActive="active-link">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="users-02">
                <path id="Icon"
                  d="M16 3.46776C17.4817 4.20411 18.5 5.73314 18.5 7.5C18.5 9.26686 17.4817 10.7959 16 11.5322M18 16.7664C19.5115 17.4503 20.8725 18.565 22 20M2 20C3.94649 17.5226 6.58918 16 9.5 16C12.4108 16 15.0535 17.5226 17 20M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5Z"
                  stroke="#E5E8EC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </g>
            </svg>
            <span style="margin-left: 10px">Mentors</span>
          </a>
        </li>
      </div>
      <!-- ************** SIGUI  ************** -->
      <div class="mb-4">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">Sigui</li>
        <li>
          <a [routerLink]="['appels/sigui-certificat']" class="nav_item" routerLinkActive="active-link">
            <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" style="fill: #e5e8ec">
              <g id="Setting">
                <path fill="#F3F4F6" stroke="#F3F4F6" stroke-width="2"
                  d="M4,12H8.059a8.9963,8.9963,0,0,0,17.882,0H60a1,1,0,0,0,0-2H25.941A8.9963,8.9963,0,0,0,8.059,10H4a1,1,0,0,0,0,2ZM17,4a7,7,0,1,1-7,7A7.0085,7.0085,0,0,1,17,4Z" />
                <path fill="#F3F4F6" stroke="#F3F4F6" stroke-width="2"
                  d="M60,31H55.941a8.9963,8.9963,0,0,0-17.882,0H4a1,1,0,0,0,0,2H38.059a8.9963,8.9963,0,0,0,17.882,0H60a1,1,0,0,0,0-2ZM47,39a7,7,0,1,1,7-7A7.0085,7.0085,0,0,1,47,39Z" />
                <path fill="#F3F4F6" stroke="#F3F4F6" stroke-width="2"
                  d="M60,52H33.941a8.9963,8.9963,0,0,0-17.882,0H4a1,1,0,0,0,0,2H16.059a8.9963,8.9963,0,0,0,17.882,0H60a1,1,0,0,0,0-2ZM25,60a7,7,0,1,1,7-7A7.0085,7.0085,0,0,1,25,60Z" />
              </g>
            </svg>
            <span class="ml-3">Gestion des Certificats</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['appels/listAppels']" class="nav_item" routerLinkActive="active-link">
            <svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg"
              style="width: 28px; height: 22px; margin-left: -4px">
              <rect fill="none" />
              <path d="M159.4,40A80.1,80.1,0,0,1,216,96.6" fill="none" stroke="#F3F4F6" stroke-linecap="round"
                stroke-linejoin="round" stroke-width="8" />
              <path d="M151.1,70.9a47.9,47.9,0,0,1,34,34" fill="none" stroke="#fff" stroke-linecap="round"
                stroke-linejoin="round" stroke-width="8" />
              <path
                d="M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z"
                fill="none" stroke="#F3F4F6" stroke-linecap="round" stroke-linejoin="round" stroke-width="12" />
            </svg>
            <span class="ml-2">Gestion des Appels</span>
          </a>
        </li>
        <li>
          <a routerLink="softskills/liste" class="nav_item" routerLinkActive="active-link">
            <svg height="32" id="icon" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
              <defs></defs>
              <path d="M30,30H22V4h8Zm-6-2h4V6H24Z" fill="#E5E8EC" />
              <path d="M20,30H12V12h8Z" fill="#E5E8EC" />
              <path d="M10,30H2V18h8Z" fill="#E5E8EC" />
              <rect style="fill: none; color: #e5e8ec" data-name="&lt;Transparent Rectangle&gt;" height="32"
                id="_Transparent_Rectangle_" width="32" />
            </svg>
            <span class="ml-3">Gestion des Soft Skills</span>
          </a>
        </li>
        <li>
          <button (click)="toggleCollapse(1)" class="toggle-button bg-transparent pr-5">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path fill="none" stroke="#E5E8EC" stroke-width="30"
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
            </svg>
            Sessions SIGUI
            <i [class.pi]="true" [class.pi-chevron-down]="sections[0].isCollapsed"
              [class.pi-chevron-up]="!sections[0].isCollapsed" style="margin-left: auto"></i>
          </button>

          <div [@slideToggle]="sections[0].isCollapsed ? 'closed' : 'open'" class="animated-paragraph"
            style="margin-left: 8px">
            <ul>
              <li *ngFor="let family of listFamily">
                <ng-container *ngIf="family.shortName">
                  <div (click)="toggleOfftrack(family)" class="nav_item cursor-pointer flex items-center py-1">
                    <i [class]="
                        family.isCollapsed
                          ? 'pi pi-chevron-right'
                          : 'pi pi-chevron-down'
                      " class="text-xs ms-2 text-white"></i>
                    <span class="ms-2 text-sm font-bold uppercase text-white">{{
                      family.shortName
                      }}</span>
                  </div>

                  <ul *ngIf="!family.isCollapsed">
                    <li *ngFor="let cohorteName of family.cohorteNames">
                      <a class="nav_item flex items-center py-1 cursor-pointer" routerLinkActive="active-link"
                        (click)="sessionChange(cohorteName)">
                        <i class="pi pi-chevron-right text-xs ms-4"></i>
                        <span class="ms-2 text-xs">{{ cohorteName }}</span>
                      </a>
                    </li>
                  </ul>
                </ng-container>
              </li>
            </ul>
          </div>
        </li>

        <!-- *********************** Sessions hORS sigui DEBUT ********************* -->
        <li>
          <button (click)="toggleCollapse(3)" class="toggle-button bg-transparent pr-5">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path fill="none" stroke="#E5E8EC" stroke-width="30"
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
            </svg>
            Sessions Hors SIGUI
            <i [class.pi]="true" [class.pi-chevron-down]="sections[2].isCollapsed"
              [class.pi-chevron-up]="!sections[2].isCollapsed" style="margin-left: auto"></i>
          </button>
         <div [@slideToggle]="sections[2].isCollapsed ? 'closed' : 'open'" class="animated-paragraph"
  style="margin-left: 8px">
  <ul>
    <!-- Niveau 1 : Pays -->
    <li *ngFor="let country of listofftrack">
      <div (click)="toggleOfftrack(country)" class="nav_item cursor-pointer flex items-center py-1">
        <i [class]="country.isCollapsed ? 'pi pi-chevron-right' : 'pi pi-chevron-down'"
          class="text-xs ms-2 text-white"></i>
        <span class="ms-2 text-sm font-bold uppercase text-white">{{ country.name }}</span>
      </div>

      <!-- Niveau 2 : Année -->
      <ul *ngIf="!country.isCollapsed">
        <li *ngFor="let year of country.years">
          <div (click)="toggleOfftrack(year)" class="nav_item cursor-pointer flex items-center py-1">
            <i [class]="year.isCollapsed ? 'pi pi-chevron-right' : 'pi pi-chevron-down'"
              class="text-xs ms-4 text-white"></i>
            <span class="ms-2 text-sm font-bold text-white">{{ year.name }}</span>
          </div>

          <!-- Niveau 3 : Module acculturation / E business -->
          <ul *ngIf="!year.isCollapsed">
            <li *ngFor="let cat of year.categories">
              <div (click)="toggleOfftrack(cat)" class="nav_item cursor-pointer flex items-center py-1">
                <i [class]="cat.isCollapsed ? 'pi pi-chevron-right' : 'pi pi-chevron-down'"
                  class="text-xs ms-6 text-white"></i>
                <span class="ms-2 text-xs font-bold text-white">{{ cat.name }}</span>
              </div>

              <!-- Niveau 4 : Cohortes -->
              <ul *ngIf="!cat.isCollapsed">
                <li *ngFor="let cohorteName of cat.cohorteNames">
                  <a class="nav_item flex items-center py-1 cursor-pointer" routerLinkActive="active-link"
                    (click)="sessionChangeHparcours(cohorteName)">
                    <i class="pi pi-chevron-right text-xs ms-8"></i>
                    <span class="ms-2 text-xs">{{ cohorteName }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</div>


        </li>
        <!-- ********************** Sessions Coursera debut *************************** -->
        <li>
          <button (click)="toggleCollapse(5)" class="toggle-button bg-transparent pr-5">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path fill="none" stroke="#E5E8EC" stroke-width="30"
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
            </svg>
            Sessions Coursera
            <i [class.pi]="true" [class.pi-chevron-down]="sections[4].isCollapsed"
              [class.pi-chevron-up]="!sections[4].isCollapsed" style="margin-left: auto"></i>
          </button>
          <div [@slideToggle]="sections[4].isCollapsed ? 'closed' : 'open'" class="animated-paragraph"
            style="margin-left: 8px">
            <ul>
              <li *ngFor="let cohort of courseraCohorts">
                <a [routerLink]="['appels/coursera-dashboard/', cohort.cohorte]" class="nav_item"
                  routerLinkActive="active-link">
                  <i class="pi pi-chevron-right text-sm ms-2"></i>
                  <span class="ms-2 text-sm">{{
                    cohort.code | lowercase
                    }}</span>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </div>
      <div class="mb-4" *ngIf="isAdminFcc">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1 mt-3">
          Accompagnement
        </li>
        <li>
          <a class="nav_item" style="cursor:pointer" (click)="showIframe = true">
            <svg height="24" width="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- Porte -->
              <path d="M4 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4V3z" fill="#E5E8EC" />

              <!-- Flèche connexion -->
              <path d="M13 12h7m0 0l-3-3m3 3l-3 3" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <span class="ml-3">Connexion</span>
          </a>
        </li>
        <li>
          <a class="nav_item" [href]="urlClasseVirtuelle" target="_blank">
            <svg height="24" width="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- Écran -->
              <rect x="3" y="4" width="18" height="12" rx="2" fill="#E5E8EC" />

              <!-- Pied de l'écran -->
              <rect x="9" y="18" width="6" height="2" fill="#E5E8EC" />

              <!-- Tête utilisateur -->
              <circle cx="12" cy="9" r="2" fill="#FFFFFF" />

              <!-- Corps utilisateur -->
              <path d="M8 14c0-2 2-3 4-3s4 1 4 3" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" />

              <!-- Petit indicateur live -->
              <circle cx="19" cy="6" r="2" fill="#4CAF50" />
            </svg>

            <span class="ml-3">Classe Virtuelle</span>
          </a>
        </li>
      </div>
    </div>
    <div>
      <div class="mb-4">
        <!-- Outils -->
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Outils
        </li>
        <li>
          <a [routerLink]="['agenda/gestionnaire']" class="nav_item" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path fill="#E5E8EC" stroke="black" stroke-width="6"
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
            </svg>
            <span class="ml-2">Mon Agenda</span>
          </a>
        </li>
        <li>
          <a class="nav_item" routerLinkActive="active-link" [routerLink]="['agenda']"
            [routerLinkActiveOptions]="{ exact: true }">
            <svg style="width: 24px; height: 22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="message-dots-circle">
                <path id="Icon"
                  d="M7.5 12H7.51M12 12H12.01M16.5 12H16.51M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21ZM8 12C8 12.2761 7.77614 12.5 7.5 12.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5C7.77614 11.5 8 11.7239 8 12ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 12.2761 16.7761 12.5 16.5 12.5C16.2239 12.5 16 12.2761 16 12C16 11.7239 16.2239 11.5 16.5 11.5C16.7761 11.5 17 11.7239 17 12Z"
                  stroke="#E5E8EC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </g>
            </svg>
            <span class="ml-2">Activités</span>
          </a>
        </li>
        <!-- <li>
          <a [routerLink]="['ami']" class="nav_item" routerLinkActive="active-link">
            <svg style="width: 24px; height: 22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="list">
                <path id="Icon"
                  d="M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z"
                  stroke="#E5E8EC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </g>
            </svg>
            <span class="ml-2">ENNEMIE</span>
          </a>
        </li> -->
        <li>
          <a [routerLink]="['cms']" class="nav_item" routerLinkActive="active-link">
            <svg style="width: 24px; height: 22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="list">
                <path id="Icon"
                  d="M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z"
                  stroke="#E5E8EC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </g>
            </svg>
            <span class="ml-2">CMS</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['documents']" class="nav_item" routerLinkActive="active-link">
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 18">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M10 16.5c0-1-8-2.7-9-2V1.8c1-1 9 .707 9 1.706M10 16.5V3.506M10 16.5c0-1 8-2.7 9-2V1.8c-1-1-9 .707-9 1.706" />
            </svg>
            <span class="ml-3">Mes documents</span>
          </a>
        </li>
      </div>
    </div>
    <div *ngIf="isAdmin">
      <!-- AMI -->
      <div class="mb-4">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">AMI</li>
        <li>
          <a [routerLink]="['ami/enrolement']" class="nav_item" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }">
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M10 4v12M4 10h12" />
            </svg>

            <span class="ml-3">Enrôlement</span>
          </a>
        </li>
      </div>
      <!-- Utilisateurs -->
      <div class="mb-4">
        <!-- Utilisateurs -->
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Utilisateurs
        </li>
        <li>
          <a [routerLink]="['/dashboard/users/list']" class="nav_item" routerLinkActive="active-link">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="users-02">
                <path id="Icon"
                  d="M16 3.46776C17.4817 4.20411 18.5 5.73314 18.5 7.5C18.5 9.26686 17.4817 10.7959 16 11.5322M18 16.7664C19.5115 17.4503 20.8725 18.565 22 20M2 20C3.94649 17.5226 6.58918 16 9.5 16C12.4108 16 15.0535 17.5226 17 20M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5Z"
                  stroke="#E5E8EC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </g>
            </svg>
            <span class="ml-3">Gestion des utilisateurs</span>
          </a>
        </li>
      </div>
    </div>
    <!-- PARAMÉTRAGE -->
    <div class="mb-4">
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">
        Paramétrage
      </li>
      <li>
        <a [routerLink]="['ami/parametrage/period-config']" class="nav_item" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }">
          <svg style="width: 22px; height: 22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
              stroke="#E5E8EC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z"
              stroke="#E5E8EC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span class="ml-3">Dispositif AMI</span>
        </a>
      </li>
    </div>
    <!-- Rapports -->
    <!-- <div class="mb-4">
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">
        Rapports
      </li>
      <li>
        <a [routerLink]="['rapports/statistiques']" class="nav_item" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }">
          <svg height="32" id="icon" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
            <defs></defs>
            <path d="M30,30H22V4h8Zm-6-2h4V6H24Z" fill="#E5E8EC" />
            <path d="M20,30H12V12h8Z" fill="#E5E8EC" />
            <path d="M10,30H2V18h8Z" fill="#E5E8EC" />
            <rect style="fill: none; color: #e5e8ec" data-name="&lt;Transparent Rectangle&gt;" height="32"
              id="_Transparent_Rectangle_" width="32" />
          </svg>
          <span class="ml-3">Statistiques</span>
        </a>
      </li>
    </div> -->
    <!-- PLATEFORME LMS -->
    <!-- Scholar Vox -->
    <!-- <div class="mb-4">
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">
        Plateforme LMS
      </li>
      <div>
        <ul>
          <li>
            <button class="nav_item text-left" (click)="openUrl(urlScholarVox)">
              <svg
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
                style="transform: scale(1.1)"
              >
                <path
                  fill="#E5E8EC"
                  d="M27,4H17V3a1,1,0,0,0-2,0V4H5A3,3,0,0,0,2,7V23a3,3,0,0,0,3,3h6.7l-1.55,2.47a1,1,0,0,0,.32,1.38,1,1,0,0,0,1.38-.32L14.05,26H18l2.2,3.53a1,1,0,0,0,1.38.32,1,1,0,0,0,.32-1.38L20.3,26H27a3,3,0,0,0,3-3V7A3,3,0,0,0,27,4ZM4,7A1,1,0,0,1,5,6H27a1,1,0,0,1,1,1V20H26V19a3,3,0,0,0-3-3H21a3,3,0,0,0-3,3v1H4ZM24,20H20V19a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Zm4,3a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V22H28Z"
                />
              </svg>
              <span>Scholar Vox</span>
            </button>
          </li>
        </ul>
      </div>
    </div> -->
  </ul>
</div>

<app-iframe-modal *ngIf="showIframe" [iframeUrl]="urlFondAmorcage" (closed)="showIframe = false" />